import { createSelector } from '@ngrx/store';

import { AssociationLabel } from '@shared/models/association-label.enum';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { hiringManagerStatusAdapter } from './hiring-manager-status.reducer';

export const getHiringManagerStatusState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => state.hiringManagerStatus,
);

export const { selectEntities: getHiringManagerStatusEntities } =
  hiringManagerStatusAdapter.getSelectors(getHiringManagerStatusState);

export const statusLabelMap = {
  Submitted: 'SUBMITTED',
  Advanced: 'ADVANCED BY HIRING MANAGER',
  Rejected: 'REJECTED BY HIRING MANAGER',
};

export const CandidateHiringManagerStatusObj = {
  getCandidateHiringManagerStatus: ({ jobId, candidateId }) =>
    createSelector(getHiringManagerStatusEntities, (entities) => {
      const key = `${jobId}:${candidateId}`;
      return entities[key]
        ? {
            id: entities[key].status,
            label: statusLabelMap[entities[key].status]
              ? statusLabelMap[entities[key].status]
              : entities[key].status,
            createdDate: entities[key].createdDate,
          }
        : null;
    }),
};

export const isCandidateDirectAndSubmitHiringManagerActionIsAvailable = ({ jobId, candidateIds }) =>
  createSelector(
    getHiringManagerStatusEntities,
    getCollectionsState,
    (entities, { associationLabel }) => {
      let tempBooleanValue = true;
      candidateIds.map((candidateId) => {
        const associationLabelValue =
          !!associationLabel[jobId] && !!associationLabel[jobId][candidateId]
            ? associationLabel[jobId][candidateId]
            : null;
        const key = `${jobId}:${candidateId}`;
        const hiringManagerLabelValue = entities[key]
          ? {
              id: entities[key].status,
              label: statusLabelMap[entities[key].status]
                ? statusLabelMap[entities[key].status]
                : entities[key].status,
            }
          : null;
        tempBooleanValue =
          tempBooleanValue &&
          associationLabelValue === AssociationLabel.DIRECT &&
          !!!hiringManagerLabelValue;
      });
      return tempBooleanValue;
    },
  );
